import type { ResetPasswordSchema } from '@repo/schemas/auth/resetPassword';

import { resetPasswordErrorMessages } from '@repo/lib/messages/resetPasswordErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { AuthService } from './authService';

export function usePostPasswordReset() {
  const passwordResetMutation = useMutation({
    mutationFn: (data: ResetPasswordSchema) => AuthService.postPasswordReset(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(passwordResetMutation.error, resetPasswordErrorMessages);
  return {
    ...passwordResetMutation,
    errorMessage,
  };
}
